<div *transloco="let t" id="filter-container-root">
  <mat-chip-list [selectable]="true" [multiple]="true" class="mat-chip-list">
    <!-- orderBy simple selector -->
    <mat-chip
      [matMenuTriggerFor]="orderByMenu"
      #orderByMenuButton="matMenuTrigger"
      *ngIf="this.filters.orderAsc !== undefined"
      disableRipple
    >
      <div>Sort by: {{ orderLabel | transloco }}</div>
      <mat-icon
        [ngClass]="{
          'menu-open': orderByMenuButton.menuOpen,
          'menu-close': !orderByMenuButton.menuOpen
        }"
      >
        keyboard_arrow_down
      </mat-icon>
    </mat-chip>

    <mat-chip
      [matMenuTriggerFor]="sortByMenu"
      #sortByMenuButton="matMenuTrigger"
      *ngIf="this.filters.sort !== undefined"
      disableRipple
    >
      <div>Sort by: {{ sortLabel | transloco }}</div>
      <mat-icon
        [ngClass]="{
          'menu-open': sortByMenuButton.menuOpen,
          'menu-close': !sortByMenuButton.menuOpen
        }"
      >
        keyboard_arrow_down
      </mat-icon>
    </mat-chip>

    <!-- Region multi selector chip -->
    <mat-chip
      [matMenuTriggerFor]="regionMultiCheckboxMenu"
      #regionMultiMenuButton="matMenuTrigger"
      *ngIf="this.filters.regions && this.filters.regions.length > 0"
      disableRipple
    >
      <div *ngIf="!getSelectedRegionChips().length">Region</div>
      <div *ngIf="getSelectedRegionChips().length" class="selected-regions">
        {{ getSelectedRegionChips().length }} selected
      </div>
      <mat-icon
        [ngClass]="{
          'menu-open': regionMultiMenuButton.menuOpen,
          'menu-close': !regionMultiMenuButton.menuOpen
        }"
      >
        keyboard_arrow_down
      </mat-icon>
    </mat-chip>

    <!-- Subregion multi selector chip -->
    <mat-chip
      [matMenuTriggerFor]="subregionMultiCheckboxMenu"
      #subregionMultiMenuButton="matMenuTrigger"
      *ngIf="this.filters.subregions && this.filters.subregions.length > 0"
      disableRipple
    >
      <div *ngIf="!getSelectedSubregionChips().length">Subregion</div>
      <div *ngIf="getSelectedSubregionChips().length" class="selected-regions">
        {{ getSelectedSubregionChips().length }} selected
      </div>
      <mat-icon
        [ngClass]="{
          'menu-open': subregionMultiMenuButton.menuOpen,
          'menu-close': !subregionMultiMenuButton.menuOpen
        }"
      >
        keyboard_arrow_down
      </mat-icon>
    </mat-chip>

    <!-- Status selector chip -->
    <mat-chip
      [matMenuTriggerFor]="statusMultiCheckboxMenu"
      #statusMultiMenuButton="matMenuTrigger"
      *ngIf="this.filters.status"
      disableRipple
    >
      <div *ngIf="!getSelectedStatusChips().length">Status</div>
      <div *ngIf="getSelectedStatusChips().length" class="selected-regions">
        {{ getSelectedStatusChips().length }} selected
      </div>
      <mat-icon
        [ngClass]="{
          'menu-open': statusMultiMenuButton.menuOpen,
          'menu-close': !statusMultiMenuButton.menuOpen
        }"
      >
        keyboard_arrow_down
      </mat-icon>
    </mat-chip>

    <!-- chip below has the ngFor that receives single/simple chips -->
    <mat-chip
      *ngFor="let chip of baseSimpleChipData"
      [selected]="chip.isActive"
      (click)="onChipSelectionChange(chip, '', $event)"
      disableRipple
    >
      <mat-icon *ngIf="chip.icon">{{ chip.icon }}</mat-icon>
      <span [ngClass]="getTextStyling(chip)" class="chip-text">{{
        t(chip.filterType!)
      }}</span>
    </mat-chip>

    <!-- Series selector chip -->
    <mat-chip
      [matMenuTriggerFor]="seriesMultiCheckboxMenu"
      #seriesMultiMenuButton="matMenuTrigger"
      *ngIf="seriesChips && seriesChips.length > 0"
      disableRipple
    >
      <div *ngIf="!getSelectedSeriesChips().length">Series</div>
      <div *ngIf="getSelectedSeriesChips().length" class="selected-regions">

        <ng-container *ngIf="isSingleSelection; else multiTemplate">
          Series {{ getSelectedSeriesChips()[0].filterType | titlecase }}
        </ng-container>

        <ng-template #multiTemplate>
          {{ getSelectedSeriesChips().length }} selected
        </ng-template>

      </div>
      <mat-icon
        [ngClass]="{
          'menu-open': seriesMultiMenuButton.menuOpen,
          'menu-close': !seriesMultiMenuButton.menuOpen
        }"
      >
        keyboard_arrow_down
      </mat-icon>
    </mat-chip>

    <!-- chip that displays Clear All -->
    <mat-chip
      *ngIf="
        (getSelectedChips().length && !isSingleSelection) ||
        getSelectedStatusChips().length > 0 ||
        (getSelectedSeriesChips().length > 0 && !isSingleSelection)
      "
      class="clear-all-chip"
      disableRipple
    >
      <span (click)="unselectAll()" class="clear-all">Clear all</span>
    </mat-chip>
  </mat-chip-list>

  <!-- panel menu that expands @ orderBy by click -->
  <mat-menu #orderByMenu="matMenu" class="order-menu">
    <button
      *ngFor="let chip of this.orderAscOptions"
      (click)="onOrderByClick(chip.key)"
      mat-menu-item
    >
      {{ t(chip.text) }}
    </button>
  </mat-menu>

  <!-- panel menu that expands @ sort by click -->
  <mat-menu #sortByMenu="matMenu" class="order-menu">
    <button
      *ngFor="let chip of this.sortOptions"
      (click)="onSortByClick(chip.key)"
      mat-menu-item
    >
      {{ t(chip.text) }}
    </button>
  </mat-menu>

  <!-- panel menu that expands @ total filters click -->
  <!-- <mat-menu #filtersMenu="matMenu" class="chip-filters-menu" yPosition="below">
    <div class="chip-menu">
      <span (click)="unselectAll()" class="clear-all">Clear all</span>
      <mat-chip
        *ngFor="let chip of getSelectedChips()"
        [selected]="chip.isActive"
      >
        {{ t(chip.filterType!) }}
        <mat-icon (click)="unselectFilter(chip)">close</mat-icon>
      </mat-chip>
    </div>
  </mat-menu> -->

  <!-- panel menu that expands @ subregion multiselector click -->
  <mat-menu
    #subregionMultiCheckboxMenu="matMenu"
    class="filters-region"
    yPosition="below"
  >
    <div class="regions">
      <mat-chip
        *ngFor="let chip of subregionChips"
        [selected]="chip.isActive"
        (click)="onChipSelectionChange(chip, 'subregion', $event)"
      >
        <nb-icon icon="square-outline" *ngIf="!chip.isActive"></nb-icon>
        <nb-icon
          icon="checkmark-square-2"
          *ngIf="chip.isActive"
          class="selected"
        ></nb-icon>
        {{ t(chip.filterType!) | titlecase }}
      </mat-chip>
    </div>
  </mat-menu>

  <!-- panel menu that expands @ region multiselector click -->
  <mat-menu
    #regionMultiCheckboxMenu="matMenu"
    class="filters-region"
    yPosition="below"
  >
    <div class="regions">
      <mat-chip
        *ngFor="let chip of regionChips"
        [selected]="chip.isActive"
        (click)="onChipSelectionChange(chip, 'region', $event)"
      >
        <nb-icon icon="square-outline" *ngIf="!chip.isActive"></nb-icon>
        <nb-icon
          icon="checkmark-square-2"
          *ngIf="chip.isActive"
          class="selected"
        ></nb-icon>
        {{ t(chip.filterType!) | titlecase }}
      </mat-chip>
    </div>
  </mat-menu>

  <!-- panel menu that expands @ status multiselector click -->
  <mat-menu
    #statusMultiCheckboxMenu="matMenu"
    class="filters-region"
    yPosition="below"
  >
    <div class="regions">
      <mat-chip
        *ngFor="let chip of statusChips"
        [selected]="chip.isActive"
        (click)="onChipSelectionChange(chip, 'status', $event)"
      >
        <nb-icon icon="square-outline" *ngIf="!chip.isActive"></nb-icon>
        <nb-icon
          icon="checkmark-square-2"
          *ngIf="chip.isActive"
          class="selected"
        ></nb-icon>
        {{ t(chip.filterType!) | titlecase }}
      </mat-chip>
    </div>
  </mat-menu>

  <!-- panel menu that expands @ series multiselector click -->
  <mat-menu
    #seriesMultiCheckboxMenu="matMenu"
    class="filters-region"
    yPosition="below"
  >
    <div class="regions">
      <mat-chip
        *ngFor="let chip of seriesChips"
        [selected]="chip.isActive"
        (click)="onChipSelectionChange(chip, 'series', $event)"
      >
        <nb-icon icon="square-outline" *ngIf="!chip.isActive"></nb-icon>
        <nb-icon
          icon="checkmark-square-2"
          *ngIf="chip.isActive"
          class="selected"
        ></nb-icon>
        {{ t(chip.filterType!) | titlecase }}
      </mat-chip>
    </div>
  </mat-menu>
</div>
